import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const LIGHT = {
  bg: '#FAFAFA',
  surface: '#FFFFFF',
  border: '#E5E7EB',
  text: '#0A0A0A',
  textStrong: '#000000',
  textMuted: '#6B7280',
  textSubtle: '#9CA3AF',
  accent: '#0FC862',
  accentHover: '#0DAD57',
  accentSoft: '#E6FAF0',
  accentStrong: '#059669',
  success: '#0FC862',
  successSoft: '#E6FAF0',
  warning: '#F59E0B',
  warningSoft: '#FEF3C7',
  error: '#EF4444',
  errorSoft: '#FEE2E2',
};

const DARK = {
  bg: '#0A0A0A',
  surface: '#141414',
  border: '#262626',
  text: '#F5F5F5',
  textStrong: '#FFFFFF',
  textMuted: '#A3A3A3',
  textSubtle: '#737373',
  accent: '#22DD8A',
  accentHover: '#1DC77C',
  accentSoft: '#0F3F26',
  accentStrong: '#10B981',
  success: '#22DD8A',
  successSoft: '#0F3F26',
  warning: '#F59E0B',
  warningSoft: '#3A2A0F',
  error: '#EF4444',
  errorSoft: '#3A1616',
};

export function toneFor(c) {
  if (c >= 0.85) return 'high';
  if (c >= 0.6) return 'medium';
  return 'low';
}

export function confidenceColors(tone, isDark) {
  const palette = isDark ? DARK : LIGHT;
  if (tone === 'high') return { bg: palette.successSoft, fg: palette.success };
  if (tone === 'medium') return { bg: palette.warningSoft, fg: palette.warning };
  return { bg: palette.errorSoft, fg: palette.error };
}

const ThemeCtx = createContext({
  mode: 'light',
  effective: 'light',
  setMode: () => {},
  colors: LIGHT,
});

export function ThemeProvider({ children }) {
  const [mode, setModeState] = useState(() => {
    const stored = localStorage.getItem('clasifi-theme');
    return stored === 'auto' || stored === 'light' || stored === 'dark' ? stored : 'light';
  });

  const systemDark = window.matchMedia?.('(prefers-color-scheme: dark)').matches;
  const effective = mode === 'auto' ? (systemDark ? 'dark' : 'light') : mode;
  const colors = effective === 'dark' ? DARK : LIGHT;

  useEffect(() => {
    if (effective === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [effective]);

  const setMode = useCallback((m) => {
    setModeState(m);
    localStorage.setItem('clasifi-theme', m);
  }, []);

  return (
    <ThemeCtx.Provider value={{ mode, effective, setMode, colors }}>
      {children}
    </ThemeCtx.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeCtx);
}

export function money(v) {
  if (v === null || v === undefined) return '—';
  return `$${Number(v).toFixed(2)}`;
}
